import '../css/OpenPlayModal.css';

/**
 * Who an Open Play join covers, by name — shown on the checkout step and on
 * the confirmation. The count alone ("2 players") isn't checkable: a guest
 * paying for a group needs to see WHICH names went through, and the
 * confirmation is the screen they show at the door.
 *
 * Falls back to the booker for a legacy join saved before rosters were
 * stored.
 *
 * @param {Object} props
 * @param {Object} props.join - the openPlayJoins record.
 * @returns {JSX.Element}
 */
function OpenPlayRoster({ join }) {
  const players = join?.players?.length ? join.players : [{ name: join?.fullName, phone: join?.phone }];
  return (
    <div className="opm-roster">
      <div className="opm-section-label">Players</div>
      {players.map((player, index) => (
        // Names repeat ("Juan" twice in a family group), so the key is the
        // position — this list is never reordered.
        <div className="opm-roster-row" key={index}>
          <span className="opm-roster-num">{index + 1}</span>
          <span className="opm-roster-name">{player.name}</span>
          {player.phone && <span className="opm-roster-phone">{player.phone}</span>}
        </div>
      ))}
    </div>
  );
}

export default OpenPlayRoster;
